<template>
  <router-view> </router-view>
</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import reportCardStore from "./store.js";
import { mapGetters } from "vuex";

// const Create = () => import("../Expense/components/Create");

export default {
  name: "expense",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("reportCard", reportCardStore);
    document.title = "taleem - Report Card";
  },
  data() {
    return {
      active: null,
      createDialog: false,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    createdLead() {
      this.close();
      this.getList();
    },
    add() {
      this.createDialog = true;
    },
    close() {
      this.createDialog = false;
    },
  },
  // components: {
  //   Create,
  // },
};
</script>
